import { useEffect, useRef, useState } from 'react';

export const useCopyToClipboard = (resetMs = 2000) => {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const copy = async (value: string) => {
    if (!value) return false;

    try {
      await navigator.clipboard.writeText(value);
      setIsCopied(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setIsCopied(false), resetMs);
      return true;
    } catch {
      setIsCopied(false);
      return false;
    }
  };

  return { isCopied, copy };
};
